import React from 'react';
import { Input } from '@/components/ui/input';
import { useSignUp } from '@/contexts/signup.context';
import { DecoyForm } from './decoy.form';
import { BirthdateForm } from './birthdate.form';
import { GroupSelectForm } from './group-select.form';
import { isGroupRequired } from '@/utils/auth';
import { AccountStatus } from '@sportspredict/shared';
import { skipToken } from '@reduxjs/toolkit/query';
import { useIsRegisteredUser } from '@/hooks';
import { useGetProfileQuery } from '@/store/api';

const inputBase =
	'w-full px-4 h-[44px] rounded-full bg-[#1E2748] border border-[#506296] placeholder:text-[#B5B6BA] text-white focus:outline-none text-[16px]';

export const UserForm = () => {
	const { fullName, setFullName, birthDate } = useSignUp();
	const isRegisteredUser = useIsRegisteredUser();
	const { data: user } = useGetProfileQuery(isRegisteredUser ? undefined : skipToken);
	const hasConfirmedGroup =
		isRegisteredUser && user?.account_status === AccountStatus.Active && Boolean(user?.group);

	return (
		<form className="w-full overflow-y-auto form-maxh" autoComplete="off">
			<DecoyForm />

			<div className="flex justify-between items-center w-full mb-3">
				<span className="text-white font-bold text-sm">Create your username</span>
				<span className="text-[#B5B6BA] text-xs">Required</span>
			</div>
			<Input
				type="text"
				placeholder="Username"
				className={`${inputBase} mb-8`}
				value={fullName}
				onChange={(e) => setFullName(e.target.value)}
			/>
			<div className="flex justify-between items-center w-full mb-3 pt-5 border-t-[0.5px] border-[#1C2D4A]/50 ">
				<span className="text-white font-bold text-sm">Confirm your age</span>
				<span className="text-[#B5B6BA] text-xs">Required</span>
			</div>
			<BirthdateForm />
			{isGroupRequired(birthDate) && !hasConfirmedGroup && <GroupSelectForm />}
		</form>
	);
};
